import { InfoCircleFilled } from '@rainbow-modules/icons';
import AlertTriangle from 'components/icons/alertTriangle';
import AlertOctagon from 'components/icons/alertOctagon';
import {
    AppMessageContainer, AppMessageIcon, AppMessageText,
} from './styled';

interface Props {
    variant?: 'info' | 'warning' | 'error' | 'success';
    children?: React.ReactNode;
}

const iconMap = {
    info: <InfoCircleFilled />,
    warning: <AlertTriangle />,
    error: <AlertOctagon />,
    success: <InfoCircleFilled />,
};

const AppMessage = ({ variant = 'info', children }: Props) => (
    <AppMessageContainer>
        <AppMessageIcon variant={variant}>{iconMap[variant]}</AppMessageIcon>
        <AppMessageText variant={variant}>{children}</AppMessageText>
    </AppMessageContainer>
);

export default AppMessage;
